import { Option } from "@opendaw/lib-std";
import { Promises } from "@opendaw/lib-runtime";
export class ChainedSoundfontProvider {
    #cloud;
    #peer = Option.None;
    constructor(cloud) {
        this.#cloud = cloud;
    }
    attachPeer(provider) { this.#peer = Option.wrap(provider); }
    detachPeer() { this.#peer = Option.None; }
    async fetch(uuid, progress) {
        const result = await Promises.tryCatch(this.#cloud.fetch(uuid, progress));
        if (result.status === "resolved") {
            return result.value;
        }
        return this.#peer.match({
            none: () => { throw result.error; },
            some: peer => peer.fetch(uuid, progress)
        });
    }
}
